import { useQuery } from '@tanstack/react-query';

import { Callout } from '@/_shared/components/ui/callout';
import { useOrpc } from '@/_shared/hooks/useOrpc';

import { IamTrustPolicyNotice } from './IamTrustPolicyNotice';

/**
 * ACT2-1124 (F22d): a warehouse account copied from another workspace shares its login with the original, so a key
 * rotation on one can break the other. A copied Redshift IAM account also shows the trust-policy condition it needs.
 * Renders nothing for an account that is not a copy.
 */
export function AccountCopyWarning({ accountId }: { accountId: string | null | undefined }): React.ReactElement | null {
  const orpc = useOrpc();
  const { data } = useQuery({
    ...orpc.accountCopies.copyOf.queryOptions({ input: { accountId: accountId ?? '' } }),
    enabled: !!accountId,
  });
  if (!accountId || !data?.origin) return null;
  return (
    <>
      <Callout variant="warning">{data.origin.sharedLoginWarning}</Callout>
      {data.origin.iamTrustPolicy ? <IamTrustPolicyNotice {...data.origin.iamTrustPolicy} /> : null}
    </>
  );
}
